<template>
  <Article :title="title" :subtitle="subtitle" :header="false">
    <section class="kc-elm kc-css-911125 kc_row">
      <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="befbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="aftbgr" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="befbgr5" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="befbgr6" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="aftbgr7" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="aftbgr8" data-ssc-svg data-ssc-img-s data-ssc-img-anim></div>
      <div class="kc-row-container kc-container">
        <div class="kc-wrap-columns">
          <div class="kc-elm kc-css-498651 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
              <div class="ssc_mltttl kc-elm kc-css-117996">
                <h2 class="wr deb derb dea dera none nonea" v-html="$t('privacy_page.title')"></h2>
              </div>
              <div class="kc-elm kc-css-929354 kc_text_block">
                <span v-html="$t('privacy_page.content')"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  </Article>
</template>

<script>
import Article from "@/components/layout/Article";

export default {
  name: "Home",
  components: {
    Article
  },
  data() {
    return {
      title: "Privacy Policy",
      subtitle: "GlobalDev"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ssc-subtitle {
  color: #ffffff;
}
.kc-css-911125{
  padding-top: 80px;
  padding-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Views/Privacy.vue